// tslint:disable:max-line-length
import React from "react";
import { connect } from "react-redux";
import Sticky from "react-stickynode";
import { apiPromiseHook, createEnterHookPromise } from "../../../../../shared/flux/actions/enterHooks";
import { MatchState } from "../../../../../shared/helpers/reduxHelpers";
import { State } from "../../../../../shared/state/reducers";
import { StoreActionFactory } from "../../../../../shared/state/storeActionFactory";
import { ContactUsCard } from "../../../../components/contactUsCard";
import { HowItWorksSection } from "../../../../components/static/howItWorks/howItWorksSection";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { ActionPromises } from "../../../../state/actionPromises";
import { EnterHookPromises } from "../../../../state/enterHookPromises";
import { FaqAccordion } from "../components/";
import { getNextActionCards } from "../nextActions";
import { officeHours, officePhone, teamEmail } from "../utils";
import { ContentGrid } from "../components";

import "./home.scss";

interface StateProps {
  enquiryState: IState<IEnquiryOutput>;
  itineraryState: IState<IEnquiryItinerarySummary>;
  latestMessage: IMessage;
  countryState: IState<ICountry>;
  contentState: IKeyedState<IPagerState<IContent>>;
  ltoState: IState<ILto>;
}

const stateToProps = (state: IWebStoreState): StateProps => {
  const enquiry = state.customerEnquiry.data;

  let latestMessage: IMessage;
  if (enquiry.id && state.messagesByEnquiryId.data && state.messagesByEnquiryId.data[enquiry.id]) {
    const messageThread = state.messagesByEnquiryId.data[enquiry.id];
    latestMessage = (messageThread.thread.data || []).find(message => message.toCustomer);
  }

  const itineraryId = enquiry?.isConnected ? enquiry.currentQuoteId : undefined;

  const itineraryState = itineraryId
    ? state.customerItineraries.data[itineraryId]
    : new State<IEnquiryItinerarySummary>();

  const countryState = state.country;

  const ltoState = state.lto;

  return {
    enquiryState: state.customerEnquiry,
    itineraryState,
    latestMessage,
    countryState,
    contentState: state.contentByCollection,
    ltoState,
  };
};

class HomeComponent extends React.Component<StateProps> {
  public render() {
    const { enquiryState, itineraryState, latestMessage, countryState, contentState, ltoState } = this.props;

    return MatchState(enquiryState, {
      data: enquiry => {
        const cards = getNextActionCards(enquiry, itineraryState.data, countryState.data, ltoState.data, latestMessage)

        return (
          <div className="customer-enquiry-home width-wrapper">
            <div className="main">

              {cards.length > 0 &&
                <section className="message-section">
                  {cards}
                </section>
              }

              {MatchState(countryState, {
                data: country =>
                  <>
                    {/* ContentGrid has it's own basic check for contentState.data */}
                    <ContentGrid country={country} contentState={contentState} enquiryStatus={enquiry.enquiryStatus} />
                  </>
              })}

              <HowItWorksSection
                heading={{
                  text: "How TravelLocal works",
                }}
                cta={{
                  text: "Find out more about our mission",
                  url: WebRoutes.aboutHome(),
                }}
                columnClasses="is-full is-6-desktop"
              />

              <FaqAccordion
                heading="FAQs"
                enquiry={enquiry}
                itinerary={itineraryState?.data}
              />
              <p>If you have any other questions, don’t hesitate to contact the TravelLocal team on {officePhone} or email us at {teamEmail}. We’re available {officeHours} (excluding bank holidays).</p>
            </div>

            <div className="sidebar">
              <Sticky top=".site-header" bottomBoundary="main">
                <ContactUsCard />
              </Sticky>
            </div>

            <div style={{ clear: "both" }} />
          </div>
        );
      },
    });
  }
}
export const Home = connect(stateToProps)(HomeComponent);
export const homeOnEnter = apiPromiseHook<any>(
  EnterHookPromises.messagesByEnquiryId("enquiryId"),
  EnterHookPromises.customerEnquiryData("enquiryId", true),
  createEnterHookPromise((router, store: IWebStoreState) => {
    return [
      StoreActionFactory.thunk<IWebStoreState>(async (dispatch, getState) => {
        const updatedCountry = getState().country.data;
        if (updatedCountry) {
          return await dispatch(ActionPromises.getContentPagesForCountry({ locations: [updatedCountry.id], pageSize: 6 }));
        }
      }),
    ];
  }),
);
